import axios from 'axios'
import {API_URL} from '../constants';

const IMPORTITEMS_API_URL = `${API_URL}/importItems`;

class ImportedItemService {

    retrieveAllImportedItems() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${IMPORTITEMS_API_URL}/findAll`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        });
    }
}

export default new ImportedItemService()